@use "@fukuri-admins/ui/layout" as *;

.description {
  margin: 0;
  color: text("High");
  @include typography("Jp/14_W3");
}

.card {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: spacing("16");
  min-width: 0;
  border: 1px solid border("Tertiary");
  border-radius: borderRadius("lg");
  padding: spacing("24");
}

.cardTitle {
  display: flex;
  align-items: center;
  gap: spacing("8");
  margin: 0;
  color: text("High");
  @include typography("Jp/16_W6");
}

.cardDescription {
  margin: 0;
  color: text("Low");
  @include typography("Jp/14_W3");
}


// 電話番号は Figma の Web/En/18_B（SF Pro Bold 18px / 28px）指定。
// typography マップは Jp スケールのみを持ち対応するトークンがないため、直接指定する。
.phoneNumber {
  margin: 0;
  color: text("High");
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
}

.receptionTime {
  margin: 0;
  color: text("Low");
  @include typography("Jp/14_W3");
}
